import { uniqueId } from 'underscore';

export const createEmptyTransactionRow = () => ({
  id: uniqueId(),
  target_name: '',
  acquirer_name: '',
  transaction_date: '',
  enterprise_value: '',
  ltm_revenue: '',
  ltm_revenue_growth: '',
  ltm_ebitda: '',
  ltm_ebitda_margin: '',
  ltm_gross_margin: '',
  ntm_revenue: '',
  ntm_ebitda: '',
  cap_iq_transaction_id: null,
  comes_from_capital_iq: false,
});
